<template>
  <div
    class="flex w-full items-center justify-end whitespace-normal md:max-w-[300px]"
  >
    <div class="w-full space-y-8">
      <OrderActions :order :refreshOrders />
      <OrderLinesActions :order :refreshOrders />
    </div>
    <MoreActions :order :refreshOrders />
  </div>
</template>

<script setup lang="ts">
import type { Order } from '../../../../Tab.types'

import MoreActions from './components/MoreActions/MoreActions.vue'
import OrderActions from './components/OrderActions/OrderActions.vue'
import OrderLinesActions from './components/OrderLinesActions/OrderLinesActions.vue'

defineProps<{ order: Order; refreshOrders: () => void }>()
</script>
